<template>
    <div class="register">
        <div class="banner">
            <div class="banner-wrapper">
                <img @click="logoClick" src="../assets/images/index/logo@2x.png" alt="">
                <div class="title">楼盘库开放平台</div>
            </div>
            <form action="" v-if="formFlag">
                <div class="customer-register-title">重置密码</div>
                <div class="line"></div>
                <div class="input">
                  <input type="text" @input="phoneInput" v-model="form.phone" @blur="handleBlurPhone" @focus="hanldeFocusPhone" 
                  :class="{phone:true,isFocus:isFocusPhone}" placeholder="请输入手机号码">
                  <div class="close" v-if="phoneData" @click="phoneDataClick"></div>
                  <div class="error" v-if="phoneErr1">
                    <img src="../assets/images/register/desc_icon.png" alt="">
                    <span>手机号输入不能为空</span>
                  </div>
                  <div class="error" v-if="phoneErr2">
                    <img src="../assets/images/register/desc_icon.png" alt="">
                    <span>请输入正确的手机号</span>
                  </div>
                  <div class="error" v-if="phoneErr3">
                    <img src="../assets/images/register/desc_icon.png" alt="">
                    <span>该手机号已被注册，请直接登录</span>
                  </div>
                  <div class="error" v-if="phoneErr4">
                    <!-- <img src="../assets/images/register/desc_icon.png" alt=""> -->
                    <span>请输入正确的手机号，否则无法接收验证码</span>
                  </div>
                </div>
                <div class="identify-send-code">
                    <div :class="{identifyCode:true,isFocus:isFocusCode}">
                        <input type="text" @input="smsCodeInput" @blur="handleBlurCode" @focus="hanldeFocusCode" v-model="form.smsCode" placeholder="请输入短信验证码">
                        <div class="close" @click="smsCodeDataClick" v-if="smsCodeData"></div>
                    </div>
                    <div :class="['identify-send',isDisabled ? 'disabled' : '']" @click="smsCodeClick">{{time}}<div class="layer"></div></div>
                    <div class="error" v-if="smsCodeErr1">
                      <img src="../assets/images/register/desc_icon.png" alt="">
                      <span>验证码不能为空</span>
                    </div>
                    <div class="error" v-if="smsCodeErr2">
                      <img src="../assets/images/register/desc_icon.png" alt="">
                      <span>验证码错误，请重新输入</span>
                    </div>
                    <div class="error" v-if="smsCodeErr3">
                      <img src="../assets/images/register/desc_icon.png" alt="">
                      <span>验证码过期，请重新获取</span>
                    </div>
                </div>
                <div class="input">
                  <input type="password" @input="password1Input" v-model="form.password1" @blur="handleBlurPassword1" @focus="hanldeFocusPassword1"
                   :class="{password1:true,isFocus:isFocusPassword1}" placeholder="请设置8至20位登录密码">
                  <div class="close" v-if="password1Data" @click="password1DataClick"></div>
                  <div class="error" v-if="passwordErr1">
                    <img src="../assets/images/register/desc_icon.png" alt="">
                    <span>请输入8-20位含数字和英文的密码</span>
                  </div>
                </div>
                <div class="input">
                  <input type="password" @input="password2Input" v-model="form.password2" @blur="handleBlurPassword2" @focus="hanldeFocusPassword2"
                   :class="{password2:true,isFocus:isFocusPassword2}" placeholder="请再次输入登录密码">
                  <div class="close" v-if="password2Data" @click="password2DataClick"></div>
                  <div class="error" v-if="passwordErr2">
                    <img src="../assets/images/register/desc_icon.png" alt="">
                    <span>请再次输入登录密码</span>
                  </div>
                  <div class="error" v-if="passwordErr3">
                    <img src="../assets/images/register/desc_icon.png" alt="">
                    <span>密码输入不一致，请重新输入</span>
                  </div>
                </div>
                <div class="login" @click="registerClick">重置<div class="layer"></div></div>
            </form>

            <div class="register-success" v-if="registerSuccessFlag">
                <img class="success-logo" src="../assets/images/register/success.png" alt="">
                <div class="title">密码重置成功</div>
                <div class="text">请妥善保管您的账户信息</div>
                <div class="login" @click="loginClick">登录</div>
            </div>
        </div>
      <Modal ref="modal" :text="text"></Modal>
    </div>
</template>

<script>
import { basicSendcode, basicPassword } from "../request/api.js";

import Modal from "@/components/Modal.vue";
var interval = null;

export default {
  components: {
    Modal
  },
  data() {
    return {
      phoneData: false,
      smsCodeData: false,
      password1Data: false,
      password2Data: false,

      isFocusPhone: false,
      isFocusCode: false,
      isFocusPassword1: false,
      isFocusPassword2: false,
      text: "",
      time: "发送验证码", //倒计时
      currentTime: 61,
      isDisabled: false,

      form: {
        phone: "",
        smsCode: "",
        password1: "",
        password2: ""
      },
      phoneErr1: false,
      phoneErr2: false,
      phoneErr3: false,
      phoneErr4: false,
      smsCodeErr1: false,
      smsCodeErr2: false,
      smsCodeErr3: false,
      passwordErr1: false,
      passwordErr2: false,
      passwordErr3: false,

      formFlag: true,
      registerSuccessFlag: false
    };
  },
  watch: {
    "form.phone": function(newVal, oldVal) {
      if (newVal == "") {
        this.phoneErr1 = true;
        this.phoneErr2 = false;
        this.phoneErr3 = false;
        this.phoneErr4 = false;
      } else if (
        newVal.length != 11 ||
        !/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(newVal)
      ) {
        this.phoneErr1 = false;
        this.phoneErr2 = true;
        this.phoneErr3 = false;
        this.phoneErr4 = false;
      } else {
        this.phoneErr1 = false;
        this.phoneErr2 = false;
        this.phoneErr3 = false;
        this.phoneErr4 = false;
      }
    },
    "form.smsCode": function(newVal, oldVal) {
      if (newVal === "") {
        this.smsCodeErr1 = true;
        this.smsCodeErr2 = false;
        this.smsCodeErr3 = false;
      } else {
        this.smsCodeErr1 = false;
        this.smsCodeErr2 = false;
        this.smsCodeErr3 = false;
      }
    },
    "form.password1": function(newVal, oldVal) {
      if (
        newVal === "" ||
        newVal.length < 8 ||
        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(newVal)
      ) {
        this.passwordErr1 = true;
      } else {
        this.passwordErr1 = false;
      }
    },
    "form.password2": function(newVal, oldVal) {
      if (newVal === "") {
        this.passwordErr2 = true;
      } else {
        this.passwordErr2 = false;
      }
      if (newVal != this.form.password1) {
        this.passwordErr2 = false;
        this.passwordErr3 = true;
      } else {
        this.passwordErr2 = false;
        this.passwordErr3 = false;
      }
    }
  },
  methods: {
    phoneDataClick() {
      this.form.phone = "";
      this.phoneData = false;
    },
    phoneInput(e) {
      if (e.currentTarget.value.length > 0) {
        this.phoneData = true;
      } else {
        this.phoneData = false;
      }
    },

    smsCodeDataClick() {
      this.form.smsCode = "";
      this.smsCodeData = false;
    },
    smsCodeInput(e) {
      if (e.currentTarget.value.length > 0) {
        this.smsCodeData = true;
      } else {
        this.smsCodeData = false;
      }
    },
    password1DataClick() {
      this.form.password1 = "";
      this.password1Data = false;
    },
    password1Input(e) {
      if (e.currentTarget.value.length > 0) {
        this.password1Data = true;
      } else {
        this.password1Data = false;
      }
    },
    password2DataClick() {
      this.form.password2 = "";
      this.password2Data = false;
    },
    password2Input(e) {
      if (e.currentTarget.value.length > 0) {
        this.password2Data = true;
      } else {
        this.password2Data = false;
      }
    },
    handleBlurPhone() {
      this.isFocusPhone = false;
    },
    hanldeFocusPhone() {
      this.isFocusPhone = true;
    },
    handleBlurCode() {
      this.isFocusCode = false;
    },
    hanldeFocusCode() {
      this.isFocusCode = true;
    },
    handleBlurPassword1() {
      this.isFocusPassword1 = false;
    },
    hanldeFocusPassword1() {
      this.isFocusPassword1 = true;
    },
    handleBlurPassword2() {
      this.isFocusPassword2 = false;
    },
    hanldeFocusPassword2() {
      this.isFocusPassword2 = true;
    },
    logoClick() {
      this.$router.push("/");
    },
    smsCodeClick() {
      // 发送验证码
      if (this.form.phone === "") {
        this.phoneErr1 = true;
        this.phoneErr2 = false;
        this.phoneErr3 = false;
        this.phoneErr4 = false;
        return;
      }
      if (
        this.form.phone.length != 11 ||
        !/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.form.phone)
      ) {
        // this.text = "请输入正确的手机号，否则无法接收验证码";
        // this.$refs.modal.isShow();
        this.phoneErr1 = false;
        this.phoneErr2 = false;
        this.phoneErr3 = false;
        this.phoneErr4 = true;
        return;
      }
      this.fetchBasicSendcode();
    },
    async fetchBasicSendcode() {
      const data = await basicSendcode({ mobile: this.form.phone });
      if (data.code === 2000 && data.data.state) {
        this.text = "验证码发送成功！";
        this.$refs.modal.isShow();
        this.getCode();
      } else if (data.code === 2001) {
        this.text = "验证码发送失败！";
        this.$refs.modal.isShow();
      }
    },
    getCode() {
      var currentTime = this.currentTime;
      interval = setInterval(() => {
        currentTime--;
        this.time = currentTime + "秒重新发送";
        this.isDisabled = true;
        if (currentTime <= 0) {
          clearInterval(interval);
          this.time = "发送验证码";
          this.currentTime = 61;
          this.isDisabled = false;
        }
      }, 1000);
    },
    registerClick() {
      if (
        this.form.phone === "" &&
        this.form.smsCode === "" &&
        this.form.password1 === "" &&
        this.form.password2 === ""
      ) {
        this.phoneErr1 = true;
        this.smsCodeErr1 = true;
        this.passwordErr1 = true;
        this.passwordErr2 = true;
        return;
      }
      if (this.form.password2 === "") {
        this.passwordErr2 = true;
        return;
      } else {
        this.passwordErr2 = false;
      }
      this.fetchBasicPassword();
      // if (
      //   this.form.phone === "" ||
      //   this.form.phone.length != 11 ||
      //   !/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.form.phone)
      // ) {
      //   this.phoneErr = true;
      //   return;
      // } else {
      //   this.phoneErr = false;
      // }
      // if (!/^[0-9]+.?[0-9]*$/.test(this.form.smsCode) || this.form.smsCode.length <= 6) {
      //   this.smsCodeErr1 = true;
      //   this.smsCodeErr2 = false;
      //   this.smsCodeErr3 = false;
      //   return;
      // } else {
      //   this.smsCodeErr1 = false;
      //   this.smsCodeErr2 = false;
      //   this.smsCodeErr3 = false;
      // }
      // if (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(this.form.password1)) {
      //   this.passwordErr1 = true;
      //   return;
      // } else {
      //   this.passwordErr1 = false;
      // }
      // if (this.form.password2 === "") {
      //   this.passwordErr2 = true;
      //   return;
      // } else {
      //   this.passwordErr2 = false;
      // }
      // if (this.form.password2 != this.form.password1) {
      //   this.passwordErr2 = false;
      //   this.passwordErr3 = true;
      //   return;
      // } else {
      //   this.passwordErr2 = false;
      //   this.passwordErr3 = false;
      // }
    },
    async fetchBasicPassword() {
      const params = {
        mobile: this.form.phone,
        code: this.form.smsCode,
        password: this.form.password1
      };
      const data = await basicPassword(params);
      if (data.code === 2000 && data.data.state) {
        this.text = "重置成功";
        this.$refs.modal.isShow();
        this.formFlag = false;
        this.registerSuccessFlag = true;
      } else if (data.code === 3004) {
        // 验证码错误
        this.smsCodeErr1 = false;
        this.smsCodeErr2 = true;
        this.smsCodeErr3 = false;
      } else if (data.code === 3007) {
        // 验证码过期
        this.smsCodeErr1 = false;
        this.smsCodeErr2 = false;
        this.smsCodeErr3 = true;
      }
    },
    loginClick() {
      this.$router.push(`/`);
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 300px;
  background: url("../assets/images/register/注册@2x.png") no-repeat;
  background-size: 100% 100%;

  .banner-wrapper {
    width: 1140px;
    height: 56px;
    margin: 0 auto;
    overflow: hidden;

    img {
      width: 104px;
      height: 32px;
      float: left;
      margin-top: 12px;
      cursor: pointer;
    }

    .title {
      line-height: 56px;
      margin-left: 33px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      float: left;
      opacity: 72.25%;
    }
  }

  form {
    width: 800px;
    height: 475px;
    margin: 0 auto;
    margin-top: 104px;
    background: #ffffff;
    box-shadow: 3px 3px 11px 0px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    overflow: hidden;
    position: relative;

    .customer-register-title {
      margin-top: 48px;
      height: 24px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      text-align: center;
      color: #272727;
      line-height: 24px;
    }

    .line {
      width: 336px;
      height: 1px;
      background: rgba(0, 0, 0, 0.06);
      margin: 16px auto;
    }

    .identify-send-code {
      width: 336px;
      height: 44px;
      margin: 24px auto;
      position: relative;

      .identifyCode {
        width: 198px;
        height: 42px;
        border: 1px solid #e3e3e3;
        float: left;
        position: relative;

        &.isFocus {
          border: 1px solid #3880f4;
        }

        input {
          width: 118px;
          padding: 0 16px;
          height: 42px;
          line-height: 42px;
          float: left;
          border: none;
          outline: none;
        }
        .close {
          width: 16px;
          height: 16px;
          background: url("../assets/images/index/close.png") no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top: 14px;
          right: 16px;
          cursor: pointer;
        }
      }

      .identify-send {
        width: 120px;
        height: 44px;
        background: #3880f4;
        border-radius: 2px;
        text-align: center;
        line-height: 44px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        float: right;
        cursor: pointer;
        position: relative;

        &.disabled {
          color: #999999;
          background: #e3e3e3;
          pointer-events: none;
        }

        .layer {
          width: 120px;
          height: 44px;
          background: rgba(0, 0, 0, 0.25);
          position: absolute;
          top: 0;
          left: 0;
          display: none;
        }

        &:hover {
          .layer {
            display: block;
          }
        }
      }
    }

    .input {
      width: 334px;
      height: 44px;
      margin: 0 auto;
      margin-bottom: 24px;
      position: relative;
       .close {
        width: 16px;
        height: 16px;
        background: url("../assets/images/index/close.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 14px;
        right: 16px;
        cursor: pointer;
      }
    }

    .phone,
    .password1,
    .password2 {
      width: 302px;
      height: 42px;
      background: #ffffff;
      outline: none;
      border-radius: 2px;
      padding: 0 16px;
      border: 1px solid #e3e3e3;
      display: block;
      margin: 0 auto;

      .close {
        width: 16px;
        height: 16px;
        background: url("../assets/images/index/close.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 14px;
        right: 16px;
        cursor: pointer;
      }

      &.isFocus {
        border: 1px solid #3880f4;
      }

      &.company {
        margin-top: 32px;
      }
    }
    ::-webkit-input-placeholder {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #c0c0c0;
    }

    .login {
      width: 336px;
      height: 44px;
      background: #3880f4;
      border-radius: 2px;
      margin: 0 auto;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      text-align: center;
      line-height: 44px;
      color: #ffffff;
      cursor: pointer;

      .layer {
        width: 336px;
        height: 44px;
        background: rgba(0, 0, 0, 0.25);
        position: absolute;
        top: 0;
        left: 0;
        display: none;
      }

      &:hover {
        .layer {
          display: block;
        }
      }
    }
  }

  .register-success {
    width: 800px;
    height: 370px;
    background: #ffffff;
    box-shadow: 3px 3px 11px 0px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 104px;

    .success-logo {
      width: 72px;
      height: 72px;
      display: block;
      margin: 0 auto;
      margin-top: 72px;
    }

    .title {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      text-align: center;
      color: #272727;
      line-height: 33px;
      margin-top: 24px;
    }

    .text {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      text-align: center;
      color: #999999;
      line-height: 17px;
      margin: 8px;
    }

    .login {
      width: 96px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #3880f4;
      border-radius: 2px;
      margin: 0 auto;
      margin-top: 32px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      cursor: pointer;
    }
  }
}

.error {
  width: 235px;
  height: 44px;
  overflow: hidden;
  position: absolute;
  right: -237px;
  top: 0;

  img {
    width: 14px;
    height: 14px;
    float: left;
    margin: 15px 4px 0 16px;
  }

  span {
    float: left;
    height: 44px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #f0323c;
    line-height: 44px;
  }
}
</style>


